var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container bj-label-colon" },
    [
      _c(
        "BjDivider",
        { attrs: { "right-fixed": "" } },
        [
          _vm._v(
            _vm._s(_vm.$t("routeBusinessStockDeliveryInformView.Basic")) + " "
          ),
          _c(
            "template",
            { slot: "right" },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("backText"))),
              ]),
              _c("BjLogButton", {
                attrs: {
                  id: _vm.data.id,
                  permission: "BusinessStockDeliveryInformIndex_Log",
                  title: _vm.data.code,
                  api: "stockApi",
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "routeBusinessStockDeliveryInformView.Delivery"
                        ),
                      },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.data.code) + " "),
                      _c("BjCopyIcon", {
                        staticClass: "ml10",
                        attrs: { copy: _vm.data.code },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "routeBusinessStockDeliveryInformView.Outbound"
                        ),
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.data.outLogicWarehouseCode) + " ")]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "routeBusinessStockDeliveryInformView.Name"
                        ),
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.data.outLogicWarehouseName) + " ")]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "routeBusinessStockDeliveryInformView.Issue"
                        ),
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.data.outTypeMeaning) + " ")]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "routeBusinessStockDeliveryInformView.status"
                        ),
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              _vm.ORDER_STOCK_OUT_TYPE_LIST.bjGet(
                                _vm.data.status
                              )
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "routeBusinessStockDeliveryInformView.Buyer"
                        ),
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.data.buyMsg) + " ")]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "routeBusinessStockDeliveryInformView.Merchant"
                        ),
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.data.orderMsg) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "routeBusinessStockDeliveryInformView.Logistics"
                        ),
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.data.logisticCompany) + " ")]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "routeBusinessStockDeliveryInformView.business"
                        ),
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.data.logisticBusiness) + " ")]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "routeBusinessStockDeliveryInformView.Consignee"
                        ),
                      },
                    },
                    [
                      _c("BjDecrypt", {
                        attrs: {
                          row: _vm.data,
                          "row-key": "receiverNameMask",
                          channel: _vm.data.channelTypeCode,
                          type: _vm.ORDER_DECRYPT_NAME["receiverNameMask"],
                          "order-sn": _vm.data.platformOrderCode,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "routeBusinessStockDeliveryInformView.Contact"
                        ),
                      },
                    },
                    [
                      _c("BjDecrypt", {
                        attrs: {
                          row: _vm.data,
                          "row-key": "receiverPhoneMask",
                          channel: _vm.data.channelTypeCode,
                          type: _vm.ORDER_DECRYPT_NAME["receiverPhoneMask"],
                          "order-sn": _vm.data.platformOrderCode,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "routeBusinessStockDeliveryInformView.Shipping"
                        ),
                      },
                    },
                    [
                      _c("BjDecrypt", {
                        attrs: {
                          row: _vm.data,
                          "row-key": "addressMask",
                          channel: _vm.data.channelTypeCode,
                          type: _vm.ORDER_DECRYPT_NAME["addressMask"],
                          "order-sn": _vm.data.platformOrderCode,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "routeBusinessStockDeliveryInformView.Creation"
                        ),
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.data.creationDate) + " ")]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "routeBusinessStockDeliveryInformView.Created"
                        ),
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.data.createdName) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDivider", [
        _vm._v(
          _vm._s(_vm.$t("routeBusinessStockDeliveryInformView.Associated"))
        ),
      ]),
      _c(
        "el-form",
        { attrs: { inline: "" } },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("routeBusinessStockDeliveryInformView.Pre"),
                  },
                },
                [
                  _c(
                    "span",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.onView(0)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.data.frontRecordCode))]
                  ),
                  _c("BjCopyIcon", {
                    staticClass: "ml10",
                    attrs: { copy: _vm.data.frontRecordCode },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t(
                      "routeBusinessStockDeliveryInformView.Internal"
                    ),
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "link",
                      on: {
                        click: function ($event) {
                          return _vm.$toBusinessOrderInternalView(
                            _vm.data.orderCode
                          )
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.data.orderCode))]
                  ),
                  _c("BjCopyIcon", {
                    staticClass: "ml10",
                    attrs: { copy: _vm.data.orderCode },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("routeBusinessStockDeliveryInformView.Third"),
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "link",
                      on: {
                        click: function ($event) {
                          return _vm.$toBusinessThirdOrderView(
                            _vm.data.platformOrderCode
                          )
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.data.platformOrderCode))]
                  ),
                  _c("BjCopyIcon", {
                    staticClass: "ml10",
                    attrs: { copy: _vm.data.platformOrderCode },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t(
                      "routeBusinessStockDeliveryInformView.result"
                    ),
                  },
                },
                [
                  _c(
                    "span",
                    { staticClass: "link" },
                    _vm._l(
                      _vm.data.resultCodeAndIdList,
                      function (item, index) {
                        return _c("span", { key: index }, [
                          _c(
                            "span",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.$toBusinessStockDeliveryResultView(
                                    item.id
                                  )
                                },
                              },
                            },
                            [_vm._v(_vm._s(index > 1 ? "" : item.code))]
                          ),
                          _vm.data && _vm.data.resultCodeAndIdList.length > 1
                            ? _c("span", [
                                _vm._v(_vm._s(index === 0 ? "，" : "")),
                              ])
                            : _vm._e(),
                        ])
                      }
                    ),
                    0
                  ),
                  _vm.data && _vm.data.resultCodeAndIdList.length > 2
                    ? _c(
                        "el-button",
                        {
                          staticClass: "ml10",
                          attrs: { type: "text", size: "small" },
                          on: { click: _vm.onMore },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "routeBusinessStockDeliveryInformView.View"
                              )
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDivider", [
        _vm._v(_vm._s(_vm.$t("routeBusinessStockDeliveryInformView.Product"))),
      ]),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          "query-params": _vm.queryParams,
          serial: _vm.serial,
          selection: false,
          stripe: false,
          "search-btn-hide": "",
          "right-toolbar-hide": "",
          "row-key": "id",
          "no-auto-height": "",
        },
        on: { handleSelectionChange: _vm.handleSelectionChange },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return undefined
            },
            proxy: true,
          },
          {
            key: "startBtnGroup",
            fn: function () {
              return undefined
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("routeBusinessStockDeliveryInformView.SKU"),
                    prop: "skuName",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t(
                      "routeBusinessStockDeliveryInformView.SKUcode"
                    ),
                    prop: "skuCode",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t(
                      "routeBusinessStockDeliveryInformView.Shipment"
                    ),
                    prop: "plannedQty",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t(
                      "routeBusinessStockDeliveryInformView.Quantity"
                    ),
                    prop: "alreadyOutQty",
                    align: "center",
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "paginationLeft",
            fn: function () {
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("routeBusinessStockDeliveryInformView.Total")
                    ) +
                      _vm._s(_vm.qtyData.plannedQty) +
                      " "
                  ),
                ]),
                _c("span", { staticClass: "ml20" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("routeBusinessStockDeliveryInformView.shipped")
                    ) + _vm._s(_vm.qtyData.alreadyOutQty)
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("tableDialog", { ref: "codeTable" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }